import React, { useEffect, useState } from 'react'
import './Card1.css'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { useParams, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Stepper from 'react-stepper-horizontal'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Link } from 'react-router-dom'

export const Card1 = (props) => {
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  // fetching user from local storage
  const user = localStorage.getItem('user')
  const token = localStorage.getItem('token')
  toast.configure()
  const [data, setData] = useState()
  const [round, setRound] = useState('')
  const params = useParams()

  const [firstPhone, setFirstPhone] = useState('')
  const [secondPhone, setSecondPhone] = useState('')

  // onchange func for input
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  // fetch personal details of candidate
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchFormData',
        { id: params.id },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        setData(response.data.currentRoundData[0])
        setRound(response.data.currentRoundData[0].interview_round)
        setFirstPhone(response.data.currentRoundData[0].reference1_contact)
        setSecondPhone(response.data.currentRoundData[0].reference2_contact)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.email])

  // update personal details of candidate
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'candidate/updateFormData',

        {
          nextRoundEmailStatus: false,
          email: data.email,
          applied_date: data.applied_date,
          interviewer_name: data.interviewer_name,
          interview_round: data.interview_round,
          interview_date: data.interview_date,
          interview_time: data.interview_time,
          interview_feedback: data.interview_feedback,
          remarks_hr: data.remarks_hr,
          status_hr: data.status_hr,
          final_status: data.final_status,
          relocate_to_ahmedabad: data.relocate_to_ahmedabad,
          other_offer_on_hand: data.other_offer_on_hand,
          joinig_date: data.joinig_date,
          offered_salary: data.offered_salary,
          offered_bonus: data.offered_bonus,
          final_remarks: data.final_remarks,
          candidate_name: data.candidate_name,
          candidate_linkedin: data.candidate_linkedin,
          contact: data.contact,
          current_ctc: data.current_ctc,
          expected_ctc: data.expected_ctc,
          designation: data.designation,
          relevant_it_experience: data.relevant_it_experience,
          current_organisation: data.current_organisation,
          notice_period: data.notice_period,
          reason_for_job_change: data.reason_for_job_change,
          reference1_contact: firstPhone,
          reference1_name: data.reference1_name,
          reference2_contact: secondPhone,
          reference2_name: data.reference2_name,
          modifierEmail: user,
          interviewImage: '',
          eligible_for_next_round:
            data.eligible_for_next_round === '' ||
            data.eligible_for_next_round === null
              ? 'NA'
              : data.eligible_for_next_round,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        toast.success('personal information updated successfully', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  return (
    <>
      <div className=" mt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/home" className="link text-primary">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item ">Candidate Profile</li>
            <li className="breadcrumb-item active" aria-current="page">
              {data ? data.candidate_name : ''}
            </li>
          </ol>
        </nav>
      </div>
      <div>
        <div>
          <Stepper
            steps={[
              { title: 'Round 1' },
              { title: 'Round 2' },
              { title: 'Round 3' },
            ]}
            activeStep={round.substring(6, 7) - 1}
          />
        </div>
        <form onSubmit={postData}>
          {data ? (
            <div className="card mt-4 p-4 applicantCard">
              <div className="row g-2">
                <h5 className="mb-4 text-primary">Personal Informations</h5>
                <div className="col-md ">
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.candidate_name}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">Name</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="email"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.email}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">Email address</label>
                  </div>

                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.contact}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">Phone/Mobile</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.current_location}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">Current Location</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.permanent_place}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">
                      Permanent/Native Location
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      name="designation"
                      defaultValue={data.designation}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">Position</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.relevant_it_experience}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">
                      Relevant Experience in the industry
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.current_organisation}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">
                      Current Organization
                    </label>
                  </div>
                </div>
                <div className="col-md ">
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.notice_period}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">Notice Period</label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      defaultValue={data.reason_for_job_change}
                      disabled
                      readOnly
                    />
                    <label htmlFor="floatingInputGrid">
                      Reason for job Change
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="number"
                      className="form-control"
                      id="floatingInputGrid"
                      name="current_ctc"
                      defaultValue={data.current_ctc}
                      onChange={handleChange}
                      step="0.0001"
                    />
                    <label htmlFor="floatingInputGrid">
                      Current CTC In LPA
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="number"
                      className="form-control"
                      id="floatingInputGrid"
                      name="expected_ctc"
                      defaultValue={data.expected_ctc}
                      onChange={handleChange}
                      step="0.0001"
                    />
                    <label htmlFor="floatingInputGrid">
                      Expected CTC In LPA
                    </label>
                  </div>

                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      name="reference1_name"
                      defaultValue={data.reference1_name}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      First Reference Name and Contact
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <PhoneInput
                      country={'in'}
                      value={firstPhone}
                      onChange={setFirstPhone}
                      enableSearch
                      inputStyle={{ width: '100%', height: '3.59rem' }}
                    />
                  </div>
                  <div className="form-floating mb-2">
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGrid"
                      name="reference2_name"
                      defaultValue={data.reference2_name}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInputGrid">
                      Second Reference Name and Contact
                    </label>
                  </div>
                  <div className="form-floating mb-2">
                    <PhoneInput
                      country={'in'}
                      value={secondPhone}
                      enableSearch
                      onChange={setSecondPhone}
                      inputStyle={{ width: '100%', height: '3.59rem' }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button className="btn btn-primary">Update</button>
                    {data.candidate_linkedin === '' ||
                    data.candidate_linkedin.toString().length < 15 ? (
                      <button
                        type="button"
                        className="btn btn-outline-primary disabled"
                      >
                        View Linkedin Profile
                      </button>
                    ) : (
                      <a
                        href={data.candidate_linkedin}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                        >
                          View Linkedin Profile
                        </button>
                      </a>
                    )}
                    <a
                      href={data.candidate_resume}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <button type="button" className="btn btn-outline-primary">
                        View Resume
                      </button>{' '}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </form>
      </div>
    </>
  )
}
